import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';
import { CommandTemplate } from '../../../../../core/entities/commandTemplate/commandTemplate';
import { TaskFormHandler } from '../task-form-handler.interface';

/**
 * Default form view component for tasks without forms
 */
@Component({
  selector: 'app-default-form-view',
  template: `
    <div class="flex justify-end mt-2">
      @if(task()?.state !== 'COMPLETED') {
      <nx-default-button
        [style]="'accent'"
        [disabled]="disabled()"
        [label]="commandTemplate()?.settings?.label"
        (click)="complete.emit()">
      </nx-default-button>
      } @else {
      <nx-default-button
        [style]="'accent'"
        [disabled]="true"
        [label]="'Erledigt'">
      </nx-default-button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultFormViewComponent {
  readonly task = input.required<Task>();
  readonly template = input<ControlTemplate | null>(null);
  readonly commandTemplate = input<CommandTemplate | null>(null);
  readonly disabled = input(true);
  readonly handler = input.required<TaskFormHandler>();
  
  readonly complete = output<void>();
}
